import * as Yup from 'yup'
import { Formik } from 'formik'

import {
  Grid,
  Card,
  Divider,
  Container,
  Dialog,
  CardContent,
  TextField,
  DialogTitle,
  IconButton,
  Typography,
  Checkbox,
  Button,
  InputLabel
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'
import { useState } from 'react'
import SubBusinessDailog from './SubBusinessDailog'
import { getBusinessDetails } from '../../../components/tsComponents/AuthGuard'

function OutletDialog({
  visible,
  onCancel,
  onSubmit,
  initialValue,
  title,
  okText,
  forFranchiseCreation = false,
  onSkip
}) {
  if (initialValue == undefined)
    initialValue = {
      name: '',
      gstn: '',
      contact_number: '',
      fax: '',
      address: '',
      city: '',
      pincode: '',
      state: '',
      country: '',
      address: '',
      sub_business_name: ''
    }
  if (initialValue.address == undefined) initialValue.address = ''
  if (initialValue.fax == undefined) initialValue.fax = ''

  if (initialValue.gstn == undefined) {
    initialValue.gstn = ''
  }

  const [selfBusiness, setSelfBusiness] = useState(false)
  const [openSubBusinessDialog, setOpenSubBusinessDialog] = useState(false)
  const [isExistingSubBusiness, setIsExistingSubBusiness] = useState(false)
  const businessDetails = getBusinessDetails()

  const handleSubmit1 = async (
    values,
    { setErrors, setStatus, setSubmitting }
  ) => {
    try {
      // Pass the isExistingSubBusiness flag with the values
      await onSubmit(values, selfBusiness, isExistingSubBusiness)
      setStatus({ success: true })
      setSubmitting(false)
    } catch (error) {
      setStatus({ success: false })
      setSubmitting(false)
    }
  }

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Required')
      .min(2, 'Name must be at least 2 characters')
      .max(30, 'Name must be at most 30 characters'),
    contact_number: Yup.string()
      .min(10, 'Min 10 digits')
      .max(10, 'Max 10 digits')
      .required('Required'),
    city: Yup.string().required('Required'),
    address: Yup.string().required('Required'),
    pincode: Yup.string().required('Required'),
    state: Yup.string().required('Required'),
    country: Yup.string().required('Required'),
    sub_business_name: Yup.string()
      .required('Required')
      .min(2, 'Min 2 characters')
      .max(30, 'Max 30 characters')
      // Not required - user can proceed without selecting a sub-business
  })

  return (
    <Dialog maxWidth="sm" fullWidth open={visible}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {title}
        <IconButton
          component="span"
          size="small"
          sx={{ ':hover': { backgroundColor: 'red', color: 'white' } }}
          onClick={() => {
            setSelfBusiness(false)
            onCancel()
          }}
          variant="contained"
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <Container sx={{ marginBottom: 5 }}>
        <Formik
          initialValues={initialValue}
          validationSchema={validationSchema}
          onSubmit={handleSubmit1}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
            status
          }) => (
            <form onSubmit={handleSubmit}>
              <Divider my={2} />
              <Card>
                <CardContent>
                  <Grid container spacing={6}>
                    <Grid item md={6}>
                      <TextField
                        sx={{ fontWeight: 'bold' }}
                        size="small"
                        name="name"
                        label="Name"
                        // disabled
                        value={values.name}
                        error={Boolean(touched.name && errors.name)}
                        fullWidth
                        helperText={touched.name && errors.name}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="contact_number"
                        label="Contact Number"
                        value={values.contact_number}
                        error={Boolean(
                          touched.contact_number && errors.contact_number
                        )}
                        fullWidth
                        helperText={
                          touched.contact_number && errors.contact_number
                        }
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={6} alignItems={'center'}>
                    <Grid item md={6}>
                      <TextField
                        sx={{ fontWeight: 'bold' }}
                        size="small"
                        name="sub_business_name"
                        label="Sub Business"
                        disabled={selfBusiness}
                        value={values.sub_business_name}
                        error={Boolean(
                          touched.sub_business_name && errors.sub_business_name
                        )}
                        fullWidth
                        helperText={
                          touched.sub_business_name && errors.sub_business_name
                        }
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={(e) => {
                          handleChange(e);
                          // Reset isExistingSubBusiness flag when manually typing
                          setIsExistingSubBusiness(false);
                        }}
                        variant="outlined"
                        my={2}
                        // select
                        InputProps={{
                          endAdornment: (
                            <Button
                              title="Select Sub Business"
                              disabled={selfBusiness}
                              size="medium"
                              onClick={() => {
                                setOpenSubBusinessDialog(true)
                              }}
                            >
                              Select
                            </Button>
                          )
                        }}
                      />
                      <SubBusinessDailog
                        open={openSubBusinessDialog}
                        onClose={() => setOpenSubBusinessDialog(false)}
                        onSubmit={(subBusinessName) => {
                          values.sub_business_name = subBusinessName
                          // Mark that this sub-business was selected from the dropdown
                          // rather than manually entered
                          setIsExistingSubBusiness(true)
                          setOpenSubBusinessDialog(false)
                        }}
                      />
                    </Grid>
                    <Grid item md={4}>
                      <Grid container alignItems={'center'}>
                        <Grid item>
                          <InputLabel>Self Business</InputLabel>
                        </Grid>
                        <Grid item>
                          <Checkbox
                            title="Self Business"
                            checked={selfBusiness}
                            onChange={(e) => {
                              if (e.target.checked) {
                                values.sub_business_name = businessDetails?.name
                                values.gstn = businessDetails?.gstn ?? ''
                                values.contact_number =
                                  businessDetails?.telephone ?? ''
                                values.fax = businessDetails?.fax ?? ''
                                values.address = businessDetails?.address ?? ''
                                values.city = businessDetails?.city ?? ''
                                values.pincode = businessDetails?.pin ?? ''
                                values.state = businessDetails?.state ?? ''
                                values.country = businessDetails?.country ?? ''
                              } else {
                                values.sub_business_name = ''
                                values.gstn = ''
                                values.contact_number = ''
                                values.fax = ''
                                values.address = ''
                                values.city = ''
                                values.pincode = ''
                                values.state = ''
                                values.country = ''
                              }
                              setSelfBusiness(e.target.checked)
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container spacing={6}>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="gstn"
                        label="GSTN"
                        value={values.gstn}
                        error={Boolean(touched.gstn && errors.gstn)}
                        fullWidth
                        helperText={touched.gstn && errors.gstn}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="fax"
                        label="Fax"
                        value={values.fax}
                        error={Boolean(touched.fax && errors.fax)}
                        fullWidth
                        helperText={touched.fax && errors.fax}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={6}>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="pincode"
                        label="PinCode"
                        value={values.pincode}
                        error={Boolean(touched.pincode && errors.pincode)}
                        fullWidth
                        helperText={touched.pincode && errors.pincode}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="city"
                        label="City"
                        value={values.city}
                        error={Boolean(touched.city && errors.city)}
                        fullWidth
                        helperText={touched.city && errors.city}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={6}>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="state"
                        label="State"
                        value={values.state}
                        error={Boolean(touched.state && errors.state)}
                        fullWidth
                        helperText={touched.state && errors.state}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        size="small"
                        name="country"
                        label="Country"
                        value={values.country}
                        error={Boolean(touched.country && errors.country)}
                        fullWidth
                        helperText={touched.country && errors.country}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        my={2}
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={6}>
                    <Grid item md={12}>
                      <TextField
                        size="small"
                        name="address"
                        label="Address"
                        value={values.address}
                        error={Boolean(touched.address && errors.address)}
                        fullWidth
                        helperText={touched.address && errors.address}
                        onBlur={handleBlur}
                        margin="dense"
                        onChange={handleChange}
                        variant="outlined"
                        multiline
                        my={2}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              <Grid
                container
                justifyContent={
                  forFranchiseCreation ? 'space-between' : 'flex-end'
                }
              >
                {forFranchiseCreation && (
                  <Grid item>
                    <Grid
                      container
                      direction={'row'}
                      justifyContent={'center'}
                      alignItems={'center'}
                    >
                      <Grid item>
                        <Typography variant="body2">
                          Already have an outlet?
                        </Typography>
                      </Grid>
                      <Grid item>
                        <ActionButton
                          // variant="outlined"
                          size="medium"
                          onClick={onSkip}
                        >
                          Skip
                        </ActionButton>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                <Grid item>
                  <ActionButton
                    variant="outlined"
                    size="medium"
                    type="submit"
                    mt={8}
                  >
                    {selfBusiness ? 'Create' : okText}
                  </ActionButton>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Container>
    </Dialog>
  )
}

export default OutletDialog
